class PostLoginNotification {
  
  constructor () {
    this.notificationTitle = '';
    this.currentRouteName = $('#page_url').val();
    this.storagePrefix = 'nc_';
  }
  
  postLoginPopup () {
    $.ajax({
      type: "GET",
      url: '/dashboard/popup-notification',
      data: {'page': true},
      success: (response) => {
        if (response.success) {
          let data = (response.data || []).filter((item) => {
            return !localStorage.getItem(this.getStorageKey(item));
          }).shift();
          if (data) {
            this.notificationTitle = data.name;
            // eslint-disable-next-line no-undef
            showPopupContent(data.properties.title, 900,
              () => window.postLoginNotificationObj.getPostLoginNotificationContent(data));
            this.invokeDisableNotification(data);
            this.appendUserToAdminPageProperties(data.id);
          }
        }
      },
      error: (err) => {
        console.log(err);
      }
    });
  }
  
  getStorageKey(data) {
    return this.storagePrefix + data.name + data?.properties?.notification_start_date
  }
  
  invokeDisableNotification (data) {
    $('#disable-post-login-notification').on('click', () => {
      localStorage.setItem(this.getStorageKey(data), true);
      hideConfirmationPopup();
    });
  }
  
  getPostLoginNotificationContent (data) {
    var popupData = data;
    return `<div id="post-login-notification-content">
                    <p>${popupData.content}</p>
                    <div class="align-text-right">
                        <button class="popup-cancel bbutton sub-action-btn" onclick="hideConfirmationPopup()">Cancel</button>
                        <button class="popup-confirmation bbutton" id="disable-post-login-notification">Don't show this again</button>
                    </div>
                </div>`;
  }
  
  appendUserToAdminPageProperties (adminPageId) {
    $.ajax({
      type: "POST",
      url: '/dashboard/mark-notification-viewed',
      data: {adminPageId: adminPageId},
      dataType: 'json',
      success: (response) => {
      },
      error: (err) => {
        console.log(err);
      }
    });
  }
}

window.postLoginNotificationObj = new PostLoginNotification();

var postLoginNotification = new PostLoginNotification();
if (['dash', 'landing'].includes(postLoginNotification.currentRouteName)) {
  postLoginNotification.postLoginPopup();
}
